import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getLocalSchedule = api((scheduleId) =>
    query(
        gql`
            query GetLocalSchedule($scheduleId: String!) {
                getLocalSchedule(scheduleId: $scheduleId) {
                    title
                    code
                    id
                    _id
                    version
                }
            }
        `,
        {
            scheduleId,
        },
        {
            returns: "getLocalSchedule",
        }
    )
)
